document.querySelectorAll('.dropdown-button').forEach(button => {
  button.addEventListener('click', () => {
    // Toggle den aktuellen Dropdown
    const content = button.nextElementSibling;
    content.classList.toggle('active');
    button.classList.toggle('active'); // Pfeil-Ausrichtung ändern
  });
});



// timer start


document.addEventListener("DOMContentLoaded", function(event) {
  // Function to update countdown
  function updateCountdown() {
    // Set the date we're counting down to (today at 23:59:00)
    var today = new Date();
    var countDownDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 0).getTime();

    // Update the countdown every second
    var x = setInterval(function() {
      // Get the current date and time
      var now = new Date().getTime();

      // Calculate the time remaining between now and the countdown date
      var distance = countDownDate - now;

      // Calculate days, hours, minutes, and seconds remaining
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Add leading zeros if the value is a single digit
      days = String(days).padStart(2, '0');
      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      seconds = String(seconds).padStart(2, '0');

      // Display the countdown in the element with id="countdown"
      document.getElementById("countdown").innerHTML = `${days}:${hours}:${minutes}:${seconds}`;

      // If the countdown is over, display a message
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown").innerHTML = "00:00:00:00";
        // Update countdown for the next day
        updateCountdown();
      }
    }, 1000); // Update every second
  }

  // Initial call to start countdown
  updateCountdown();
});


// timer  end